import { Badge } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faExclamationTriangle, faTimes } from '@fortawesome/free-solid-svg-icons';

export const getStatusBadge = (type, count) => {
  if (count === 0) return null;
  
  const variants = {
    success: 'success',
    errors: 'danger',
    skipped: 'warning'
  };

  const icons = {
    success: faCheck,
    errors: faTimes,
    skipped: faExclamationTriangle
  };

  return (
    <Badge variant={variants[type]} className="mr-2">
      <FontAwesomeIcon icon={icons[type]} className="mr-1" />
      {count} {type}
    </Badge>
  );
};

export const getImportSummary = (importResults) => {
  return {
    successCount: importResults.results?.database?.successful?.length || 0,
    validationErrorCount: importResults.results?.validation?.errors?.length || 0,
    databaseErrorCount: importResults.results?.database?.errors?.length || 0,
    skippedCount: importResults.results?.validation?.skipped?.length || 0,
    totalErrors: (importResults.results?.validation?.errors?.length || 0) + (importResults.results?.database?.errors?.length || 0)
  };
};